import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class BankExportDownloadResponse {
  @observable
  @Type(() => Date)
  downloadedAt!: Date;

  @observable
  downloadedBy!: string;
}
